import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import copy from 'copy-to-clipboard';
import Modal from '../Modal';
import Button from '../Button';
import Input from '../Input';
import { AuthContext } from '../../contexts/AuthContext';
import './index.scss';

const UnHandledRejection: React.FC = () => {
  const { t } = useTranslation();

  const [copyButtonTooltipText, setCopyButtonTooltipText] = useState<string>("Copy")

  const {
    exception, setException
  } = useContext(AuthContext);

  const content = (
    <div className="d-error-page unhandled-rejection">
      <i className="ri-error-warning-line ri-48px text-warning"></i>
      <h4>{t('common.errorMessages.unHandledRejectionPage.unHandledRejection')}</h4>
      <p>{t('common.errorMessages.unHandledRejectionPage.message')}</p>
      <h5 className='corelation-id d-flex align-items-center'>
        <Input 
          value={exception}
          id="exception"
          name="exception"
          className="exception-text"
          type="text"
          disabled
        />
        <span>
          <Tooltip
            title={copyButtonTooltipText}
            arrow
            classes={{
              tooltip: 'tooltip',
            }}
          >
            <i className="ri-file-copy-line cursor-pointer ri-24px" onClick={() => { copy(exception); setCopyButtonTooltipText('Copied') }} onMouseLeave={() => setCopyButtonTooltipText('Copy')}></i>
          </Tooltip>
        </span>
      </h5>

    </div>
  )

  const action = (
    <Button
      text={t('common.errorMessages.unHandledRejectionPage.closeBtn')}
      className="btn btn-primary"
      onClick={() => setException('')}
    />
  )

  return (
    <Modal
      open={exception ? true : false}
      onClose={() => setException('')}
      disableBackDrop
      disableEscape
      content={content}
      action={action}
      maxWidth="sm"
    />
  );
};

export default UnHandledRejection;
